module.exports = "/dist/images/5ce3630bf9016ade86ab3b8c7444e928-iphon.png";